import * as _ from "lodash-es";
import { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IOnUpdatePickListItemDTO from "../../../models/DTO/IOnUpdatePickListItemDTO";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import IUpdatePickListItemDTO from "../../../models/DTO/IUpdatePickListItemDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IPick_List_Catalog_Item_Detail from "../../../models/IPick_List_Catalog_Item_Detail";
import IssueReasonEnum from "../../../models/IssueReasonEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./PickListItemDetailIssueModal.scss";
import Typeahead from "../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";
import UIService from "../../../services/UIService";

type Props = {
    closeModalFn: (refreshData?: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    pickListItem: IPick_List_Catalog_Item_Detail;
    pickListGuid: string;
    readOnly: boolean;
};

type State = {
    issue_reason_id?: IssueReasonEnum;
    issue_note?: string;
    issue_qty?: number;
    sub_catalog_item_id?: number;
    hasChanges: boolean;
    subCatalogItemOptions: ICatalog_Item[];
    selectedSubCatalogItem?: ICatalog_Item;
};

class PickListItemDetailIssueModal extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        let issue_qty: number | undefined = _.get(this.props.pickListItem.Pick_List_Catalog_Item_Map, "issue_qty", 0);

        if (_.isNil(issue_qty)) {
            issue_qty = undefined;
        }

        this.state = {
            issue_reason_id: _.get(this.props.pickListItem.Pick_List_Catalog_Item_Map, "issue_reason_id"),
            issue_note: _.get(this.props.pickListItem.Pick_List_Catalog_Item_Map, "issue_note", ""),
            issue_qty,
            sub_catalog_item_id: _.get(this.props.pickListItem.Pick_List_Catalog_Item_Map, "sub_catalog_item_id"),
            hasChanges: false,
            subCatalogItemOptions: [],
            selectedSubCatalogItem: this.props.pickListItem.Pick_List_Catalog_Item_Map.Substitution_Catalog_Item,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.PickListOnUpdatePickListItem, this.onUpdatePickListItem);
        this.props.socket.on(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.PickListOnUpdatePickListItem, this.onUpdatePickListItem);
        this.props.socket.removeListener(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);
    }

    closeModal = (refreshData?: boolean) => {
        this.props.closeModalFn(refreshData);
    };

    clearIssue = () => {
        const payload: IUpdatePickListItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            pickListGuid: this.props.pickListGuid,
            pickListItemId: this.props.pickListItem.Pick_List_Catalog_Item_Map.id,
            pickListDetail: {
                has_issue: false,
                issue_reason_id: null,
                issue_qty: 0,
                issue_note: "",
                sub_catalog_item_id: null,
            },
        };

        this.props.socket.emit(EndpointsEnum.PickListUpdatePickListItem, payload);
    };

    onUpdatePickListItem = (data: IOnUpdatePickListItemDTO) => {
        this.closeModal(true);
    };

    saveAndBack = () => {
        if (this.state.hasChanges) {
            let has_issue = false;

            if (this.state.issue_reason_id && Number(this.state.issue_reason_id)) {
                has_issue = true;
            }

            let sub_catalog_item_id: number | null = null;

            if (this.state.selectedSubCatalogItem) {
                sub_catalog_item_id = this.state.selectedSubCatalogItem.id;
            }

            const payload: IUpdatePickListItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                pickListGuid: this.props.pickListGuid,
                pickListItemId: this.props.pickListItem.Pick_List_Catalog_Item_Map.id,
                pickListDetail: {
                    has_issue,
                    issue_reason_id: this.state.issue_reason_id,
                    issue_qty: this.state.issue_qty,
                    issue_note: this.state.issue_note,
                    sub_catalog_item_id,
                    qty_picked: this.props.pickListItem.Pick_List_Catalog_Item_Map.qty_picked,
                },
            };

            this.props.socket.emit(EndpointsEnum.PickListUpdatePickListItem, payload);
        } else {
            this.closeModal();
        }
    };

    handleChange = (e: ChangeEvent<any>) => {
        let value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        if (name === "issue_qty") {
            // validate that the user is within the bounds of the pick qty.
            const qtyToPick = this.props.pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick;
            const qtyPicked = Number(this.props.pickListItem.Pick_List_Catalog_Item_Map.qty_picked);

            const maxAllowed = qtyToPick - qtyPicked;

            const issueQty = Number(value);

            if (maxAllowed < issueQty) {
                value = maxAllowed;
            }
        }

        const state: any = {
            [name]: value,
            hasChanges: true,
        };

        this.setState(state);
    };

    doTypeahead = (sku: string) => {
        const payload: ITypeaheadCatalogItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.props.pickListItem.Catalog!.guid,
            name: sku,
            ignoreProductGroups: true,
            options: {
                searchName: true,
                searchDescription: true,
                searchSku: true,
                searchUpc: true,
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
    };

    onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        this.setState({
            subCatalogItemOptions: data.catalog_items,
        });
    };

    selectSubCatalogItem = (item: ICatalog_Item) => {
        this.setState({
            selectedSubCatalogItem: item,
        });
    };

    render() {
        const issueOptions = [
            { id: IssueReasonEnum.INSUFFICIENT_QTY, title: "insufficient_qty" },
            { id: IssueReasonEnum.SUBSTITUTION, title: "substitution" },
            { id: IssueReasonEnum.DAMAGED_PRODUCT, title: "damaged_product" },
            { id: IssueReasonEnum.OTHER, title: "other" },
        ];

        let location: any = (this.props.pickListItem.Warehouse_Catalog_Items_Maps || []).map((warehouseMap) => {
            return (
                <div key={warehouseMap.guid}>
                    {warehouseMap.row} {warehouseMap.bin}
                </div>
            );
        });

        if (!this.props.pickListItem.Warehouse_Catalog_Items_Maps?.length) {
            location = "--";
        }

        return (
            <div className={"PickListItemDetailIssueModal"}>
                <div className={"row"}>
                    <div className={"col-12 d-flex justify-content-between"}>
                        <div>
                            <OwButton title={"save_and_back"} fn={this.saveAndBack} />
                        </div>
                        <div>
                            <OwButton title={"clear_issue"} fn={this.clearIssue} disabled={this.props.readOnly} />
                        </div>
                    </div>
                    <div className={"col-12 d-flex justify-content-between"}>
                        <OwTitle title={"mark_issue"} tag={"h3"} />
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <OwTitle title={this.props.pickListItem.name} disableTranslation={true} tag={"h4"} />
                    </div>
                </div>

                <div className={"row mb-4"}>
                    <div className={"col-12"}>
                        <OwLabel title={"reason"} showIsReqAsterik={true} />
                        <OwSelectOption
                            options={issueOptions}
                            valueProp={"id"}
                            titleProp={"title"}
                            name={"issue_reason_id"}
                            fn={this.handleChange}
                            translateTitle={true}
                            selectedOption={this.state}
                            selectedOptionProp={"issue_reason_id"}
                            isDisabled={this.props.readOnly}
                        />
                    </div>

                    <div className={"col-12 mt-3"}>
                        <OwLabel title={"qty"} />
                        <OwInputWrapper
                            name={"issue_qty"}
                            fn={this.handleChange}
                            value={this.state.issue_qty}
                            type={"number"}
                            disabled={this.props.readOnly}
                            onWheelFn={UIService.stopScrollWheel}
                        />
                    </div>

                    {this.state.issue_reason_id && Number(this.state.issue_reason_id) === IssueReasonEnum.SUBSTITUTION ? (
                        <div className={"col-12 mt-3"}>
                            <OwLabel title={"sku"} />
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={this.doTypeahead}
                                typeaheadItems={this.state.subCatalogItemOptions}
                                titleProp={"sku"}
                                selectedItemFn={this.selectSubCatalogItem}
                                selectedItem={this.state.selectedSubCatalogItem}
                                selectedItemTitleProp={"sku"}
                                disabled={this.props.readOnly}
                            />
                        </div>
                    ) : null}

                    <div className={"col-12 mt-3"}>
                        <OwLabel title={"note"} />
                        <OwTextArea
                            name={"issue_note"}
                            fn={this.handleChange}
                            value={this.state.issue_note}
                            disabled={this.props.readOnly}
                        />
                    </div>
                </div>

                <div className={"row mt-5"}>
                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"qty"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{this.props.pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick || "--"}</div>
                    </div>

                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"loc"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{location}</div>
                    </div>

                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"sku"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{this.props.pickListItem.sku || "--"}</div>
                    </div>

                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"description"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{this.props.pickListItem.description || "--"}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PickListItemDetailIssueModal;
